import t from "./contact-channels78.js";
import a from "./contact-channels79.js";
var i = {
  require_tld: !0,
  allow_underscores: !1,
  allow_trailing_dot: !1,
  allow_numeric_tld: !1,
  allow_wildcard: !1,
  ignore_max_length: !1
};
function s(e, l) {
  t(e), l = a(l, i), l.allow_trailing_dot && e[e.length - 1] === "." && (e = e.substring(0, e.length - 1)), l.allow_wildcard === !0 && e.indexOf("*.") === 0 && (e = e.substring(2));
  var f = e.split("."), u = f[f.length - 1];
  return l.require_tld && (f.length < 2 || !l.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(u) || /\s/.test(u)) || !l.allow_numeric_tld && /^\d+$/.test(u) ? !1 : f.every(function(r) {
    return !(r.length > 63 && !l.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(r) || /[\uff01-\uff5e]/.test(r) || /^-|-$/.test(r) || !l.allow_underscores && /_/.test(r));
  });
}
export {
  s as default
};
//# sourceMappingURL=contact-channels84.js.map
